import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const FlagUa24 = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("rect", { x: "4.84998", y: "6.5", width: "14.3", height: "5.5", fill: "#005BBB" }),
    React.createElement("rect", { x: "4.84998", y: "12", width: "14.3", height: "5.5", fill: "#FFD500" })), 'FlagUa24', { width: 24, height: 24, viewBox: '0 0 24 24' });
export default FlagUa24;
